export const CANDIDATE_SIGN_UP_REQUEST = 'CANDIDATE_SIGN_UP_REQUEST';
export const CANDIDATE_SIGN_UP_SUCCESS = 'CANDIDATE_SIGN_UP_SUCCESS';
export const CANDIDATE_SIGN_UP_FAILURE = 'CANDIDATE_SIGN_UP_FAILURE';
